exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-head[data-v-1751090e] {\n  padding: 125px 0 67px;\n}\n.head .head__number[data-v-1751090e] {\n  font-size: 50px;\n}\n.head .head__link[data-v-1751090e] {\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: bold;\n  display: block;\n  margin-top: 100px;\n  line-height: 1.83;\n  letter-spacing: 0.5px;\n  opacity: 0.5;\n}\n.head .privilegions[data-v-1751090e] {\n  margin-top: 87px;\n}", ""]);

// exports
